<template>
  <div class="score">
    <span class="number">{{ score }}</span>
    <span class="label">{{ label }}</span>
    <div class="score-bar">
      <div class="bar">
        <div class="point" :style="pointPosition"></div>
      </div>
      <div class="labels">
        <span>-100</span>
        <span>0</span>
        <span>100&nbsp;</span>
      </div>
    </div>
  </div>
</template>

<script>
const props = {
  enps: {
    required: false,
  },
  label: {
    type: String,
    required: false,
    default: '',
  },
}

export default {
  props: props,

  computed: {
    score: function() {
      return this.enps.score || 0
    },

    pointPosition: function() {
      const pointRelativePosition = 50 + this.score / 2
      const compensation = (pointRelativePosition * 34) / 100

      return { left: `calc(${pointRelativePosition}% - ${compensation}px)` }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@/styles/custom/colors';

.nps-component {
  display: flex;
  flex-direction: row;
  align-items: flex-start;

  @media (max-width: 767px) {
    flex-direction: column;
  }

  .score {
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    max-width: 300px;
    min-height: 300px;
    width: 100%;
    padding: 0 10px;
    margin: 0 auto;

    .number {
      font-size: 70px;
      line-height: 4.2rem;
    }

    .label {
      color: map-get($theme-colors, 'gray03');
      line-height: initial;
    }

    .score-bar {
      align-items: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-top: 20px;
      width: 100%;

      .bar {
        align-items: center;
        background: linear-gradient(
          37deg,
          map-get($theme-colors, 'red') -16%,
          map-get($theme-colors, 'orange') 16%,
          map-get($theme-colors, 'lima') 100%
        );

        border: 1px solid map-get($theme-colors, 'gray-dark');
        border-radius: 28px;
        box-sizing: content-box;
        display: flex;
        height: 30px;
        position: relative;
        width: 100%;

        .point {
          background: white;
          border: 6px solid black;
          border-radius: 28px;
          box-sizing: content-box;
          height: 22px;
          position: relative;
          width: 22px;
        }
      }

      .labels {
        color: map-get($theme-colors, 'gray03');
        display: flex;
        font-size: 1rem;
        justify-content: space-between;
        width: 100%;
      }
    }
  }
}
</style>
